import { Typography } from 'antd';
import dayjs from 'dayjs';
import React, { FC } from 'react';
import styled from 'styled-components';
import colors from '~/constants/colors';
import { DateTimeFormat } from '~/constants/dateTime';
import longdash from '~/constants/longdash';
import theme from '~/constants/theme';

interface Props {
  children?: React.ReactNode;
}

const TextAreaField: FC<Props> = (props) => {
  const { children } = props;

  return (
    <Container>
      {children}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 8px;
  border-radius: ${theme.borderRadiusBase}px;
  background-color: ${colors.grey[100]};
  border: 1px solid ${colors.borderColorBase};
`;

export default TextAreaField;
